import styled from "styled-components";
import modalStyles from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import checkStyles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.js";

const TitleModalStyled = styled.h4`
  margin: 0;
  line-height: 1.42857143;
  font-weight: bold;
  color: ${(props) => (props.color ? `${props.color}` : "#9c27b0")};
`;
const SubtitleModalStyled = styled.span`
  word-wrap: break-word;
`;
const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
const TextAreaStyled = styled.textarea`
  resize: none;
  border-radius: 0.8rem;
  width: 100%;
  height: 200px;
  border: 1px solid #c8c8c8;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  padding: 0.6rem;
  font-size: 14px;
`;
const styles = (theme) => ({
  ...modalStyles,
  ...checkStyles,
  modalHeader: {
    ...modalStyles.modalHeader,
    display: "flex",
    justifyContent: "space-between",
  },
  marginLabel: {
    marginRight: "1rem",
  },
});

export {
  TitleModalStyled,
  TextAreaStyled,
  SubtitleModalStyled,
  CheckboxWrapper,
  styles,
};
